import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { ITspMessageRepository } from './Itsp-message.repository';
import { ApiResponse, MotivationalMessage, MotivationalMessageCustomSet } from './models';


@Injectable({ providedIn: 'root' })
export class TspMessageRepository implements ITspMessageRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	getDefaultSet(): Observable<ApiResponse<MotivationalMessage[]>> {
		return this.httpClient.get<ApiResponse<MotivationalMessage[]>>(this.configs.domainTspAPI + '/api/MotivationMessage/DefaultSet');
	}

	getCustomSetList(userId: string): Observable<ApiResponse<MotivationalMessageCustomSet[]>> {
		const params = new HttpParams().set('userId', userId);
		return this.httpClient.get<ApiResponse<MotivationalMessageCustomSet[]>>(this.configs.domainTspAPI + '/api/MotivationMessage/CustomSetList', { params });
	}

	deleteCustomSet(name: string): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('name', name);
		return this.httpClient.delete<ApiResponse<void>>(this.configs.domainTspAPI + '/api/MotivationMessage/CustomSet', { params });
	}

	renameCustomSet(name: string, newName: string): Observable<ApiResponse<void>> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		const params = new HttpParams().set('name', name);
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/MotivationMessage/RenameCustomSet', `"${newName}"`, { headers, params });
	}

	saveCustomSet(customSet: MotivationalMessageCustomSet): Observable<ApiResponse<void>> {
		return this.httpClient.put<ApiResponse<void>>(this.configs.domainTspAPI + '/api/MotivationMessage/CustomSet', customSet);
	}

}
